import { SelectionModel } from '@angular/cdk/collections';
import { Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import  moment from 'moment';
import { BehaviorSubject, forkJoin, Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap, take, takeWhile } from 'rxjs/operators';
import { CommonService } from 'src/app/services/common.service';
import { BasisVO, IssueVO, StatuteVO, SystemicCaseChargeResponse, SystemicCaseResponse } from 'src/app/services/gen';
import { NoteVO } from 'src/app/services/gen/model/models';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { WsCasesResponseInterface } from 'src/app/services/search-data.service';
import { SharedCodeService } from 'src/app/services/shared-code.service';
import {
	CONFIRM_DELETE_SYSTEMIC_CASE,
	CONFIRM_REMOVE_CASES_FROM_SYSTEMIC,
	CONFIRM_REMOVE_SYSTEMIC_CASE,
	CONFIRM_SUBSCRIBE_SYSTEMIC_CASE,
	CONFIRM_UNSUBSCRIBE_SYSTEMIC_CASE,
	DisclosableMessage,
	NonDisclosableMessage,
	OGCAdminRoleCode,
	ScrollStrategy,
	SystemicAdminRoleCode,
} from 'src/app/shared/common-structures/app.constants';
import { OfficeRole } from 'src/app/shared/common-structures/office-role';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AlertService } from 'src/app/shared/ims-alerts/ims-alerts.service';
import { StringUtils } from 'src/app/shared/utility/stringUtils';
import { Utils } from 'src/app/shared/utility/utils';
import { NotesDialogComponent } from '../notes-dialog/notes-dialog.component';
import { DocumentDialogComponent } from '../../case-details/template-library/document-dialog/document-dialog.component';
import { DashboardService } from '../../dashboard/dashboard.service';
import { DocTypes } from '../../documents/document';
import { DocumentsService } from '../../documents/documents.service';
import { DocumentsUtil, UserType } from '../../documents/documents.util';
import { ModifySystemicDialogComponent } from '../modify-systemic-dialog/modify-systemic-dialog.component';
import { SharedPartiesService } from '../shared-parties.service';
import { SystemicCaseDetailResponse } from './../../../../services/Utils/systemicCaseDetailResponse';
import { PrepaSearchResourceService } from './../../../../services/SearchDataWebService/api/prepaSearchResource.service';
import { CaseDetailsService } from './../../case-details/case-details.service';
import { SystemicService } from './../../systemic/systemic.service';

@Component({
	selector: 'app-systemic-dashboard',
	templateUrl: './systemic-dashboard.component.html',
	styleUrls: ['./systemic-dashboard.component.scss'],
})
export class SystemicDashboardComponent implements OnInit, OnChanges, OnDestroy {
	@Input() isSystemicRoleHolder: boolean;
	@Input() userDetailId: string;
	@Input() isSystemicModule: boolean;
	@Input() systemicCaseId: number;
	@Input() systemicStatus: string;

	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	@ViewChild(MatSort, { static: true }) sort: MatSort;
	@ViewChild('stepper', { static: true }) stepper: MatStepper;
	dataSource: MatTableDataSource<SystemicCaseResponse>;
	selection = new SelectionModel<SystemicCaseResponse>(true, []);
	systemicCaseArray: SystemicCaseResponse[] = [];
	selectedDashboardOffice: any = {};
	notes: NoteVO[] = [];
	selectedIndexName: string;
	noteTypes: any[] = [];
	documentTypes: any[] = [];
	parent: any = this;
	autoGeneratedIncludedDocTypes: any[] = [];
	documents: any[] = [];
	defaultColumns = [
		'select',
		'caseName',
		'numberOfCharges',
		'respondents',
		'statute',
		'basis',
		'issue',
		'owner',
		'office',
		'status',
		'subscribed',
		'actions',
	];
	displayColumns: string[] = [];
	currentSystemicCaseId: number = 0;
	filters: any = {};
	userSelectedOfficeCode: string;
	statuteLookup: StatuteVO[] = [];
	basisLookup: BasisVO[] = [];
	issueLookup: IssueVO[] = [];
	isAdrRoleHolder: boolean = false;
	relatedSystemicCaseCharges: SystemicCaseChargeResponse[] = [];
	notRelatedSystemicCaseCharges: SystemicCaseChargeResponse[] = [];
	systemicCaseCharges: SystemicCaseChargeResponse[] = [];
	systemicDetail: SystemicCaseDetailResponse;
	userSubscribedCaseIdList: number[];
	observer$ = new BehaviorSubject(true);
	isOGCAdmin: boolean = false;
	isSubscribed: boolean = false;
	buttonText: string = '';
	logs: any[] = [];
	hasOFPAdminrole: boolean;
	ariaResultAlert: number;
	adrNotes: NoteVO[] = [];
	regularNotes: NoteVO[] = [];
	hasEditRight = false;
	caseId: any = undefined;
	documentBeforeEdit;
	documentAfterEdit;
	documentDialogRef: MatDialogRef<any>;
	relatedDateToBeEdited;
	selectedCase: any;

	constructor(
		private router: Router,
		public dialog: MatDialog,
		private dashboardServ: DashboardService,
		private sharedCodeServ: SharedCodeService,
		private cmnServ: CommonService,
		private loader: LoadingService,
		private alert: AlertService,
		private caseDetailService: CaseDetailsService,
		private sharedPartiesServ: SharedPartiesService,
		private systemicServ: SystemicService,
		private prepaSearchServ: PrepaSearchResourceService,
		private docServ: DocumentsService
	) {}

	ngOnInit(): void {
		this.displayColumns = [...this.defaultColumns];
		this.systemicCaseId = undefined;
		this.cmnServ.selectedDashboardOffice$.pipe(takeWhile(() => this.observer$.value)).subscribe((res) => {
			this.selectedDashboardOffice = res;
		});
		this.getDocumentTypes();
		this.setupMatTable();
		this.getSharedCodes();
		this.getUserSubscribedSystemicCaseIdList();
		this.getSystemicCases();
		this.systemicServ.onSave.pipe(takeWhile(() => this.observer$.value)).subscribe((res) => {
			this.systemicCaseId = undefined;
			this.getSystemicCases();
		});
		this.cmnServ
			.getOfficeRoleSelection()
			.pipe(takeWhile(() => this.observer$.value))
			.subscribe((selectedOffice) => {
				this.isOGCAdmin = this.hasOGC(selectedOffice);
			});
	}

	download(fileFormat: string, fileName: string, sheetName?: string) {
		this.systemicServ.onExport.next({ format: fileFormat, fileName, sheetName: sheetName? sheetName: 'Sheet1' });
	}

	ngOnChanges(changes) {
		if (changes.systemicStatus) {
			if (this.systemicStatus == 'CLOSED') {
				this.displayColumns = this.defaultColumns.filter((x) => !['select', 'actions'].includes(x));
			} else {
				this.displayColumns = [...this.defaultColumns];
			}
		}
	}

	/**
	 * @description Setup matTable. Including dataSource initialization, binding of paginator and sorter,
	 * and setup default sort.
	 */
	setupMatTable() {
		this.dataSource = new MatTableDataSource();
		this.dataSource.data = [];
		this.dataSource.paginator = this.paginator;
		this.dataSource.sort = this.sort;
		this.dataSource.filterPredicate = (data, filters) => {
			const rs = this.displayColumns.map((item) => {
				if (Utils.isNullCondition(filters[item])) {
					return true;
				}
				// get data from rows
				let rowValue = data[item] ? data[item] : '';
				const filterValue = filters[item];
				if (item === 'numberOfCharges') {
					rowValue = rowValue?.toString();
				}
				if (item === 'status' || item === 'office') {
					rowValue = rowValue?.description || '';
				}
				if (item === 'respondents') {
					rowValue = data.caseCriteria?.respondents?.join(', ') || '';
				}
				if (item === 'statute') {
					rowValue = this.convertAllegationsToDescription(data.caseCriteria?.statute, this.statuteLookup);
				}
				if (item === 'basis') {
					rowValue = this.convertAllegationsToDescription(data.caseCriteria?.basis, this.basisLookup);
				}
				if (item === 'issue') {
					rowValue = this.convertAllegationsToDescription(data.caseCriteria?.issue, this.issueLookup);
				}
				return rowValue.toLowerCase().includes(filterValue.toLowerCase());
			});
			return rs.every(Boolean);
		};
		// setup default sort
		// const sortState: Sort = { active: 'numberOfCharges', direction: 'desc' };
		// this.sort.active = sortState.active;
		// this.sort.direction = sortState.direction;
	}

	openNotesDialog(systemicCaseId) {
		this.systemicCaseId = systemicCaseId;
		const data = {
			title: 'Notes',
			caseId: systemicCaseId,
			systemicCase: true,
		};

		const dialogRef = this.dialog.open(NotesDialogComponent, {
			minHeight: '60vh',
			height: 'auto',
			width: '80%',
			data: data,
			panelClass: 'app-dialog-container-full-height',
			disableClose: false,
			scrollStrategy: ScrollStrategy,
			id: 'notes-dialog',
		});
		dialogRef.componentInstance.notes = this.notes || [];
		dialogRef.componentInstance.isAdr = this.isAdrRoleHolder && this.selectedIndexName === 'ADR';
		dialogRef.componentInstance.subjectOptions = this.noteTypes;
		dialogRef.componentInstance.updateLabels();
		dialogRef.componentInstance.setPageData();
		const subscription = dialogRef.componentInstance.onUpdate.subscribe((res) => {
			this.notes = res;
		});
		const subjectOptionSub = dialogRef.componentInstance.subjectChange.subscribe((res) => {
			this.noteTypes = res;
		});
		dialogRef.afterClosed().subscribe((res) => {
			if (res) {
				subscription.unsubscribe();
				subjectOptionSub.unsubscribe();
			}
		});
	}

	getNotes() {
		this.loader.show();
		this.caseDetailService.getAllNotes(this.systemicCaseId, true).subscribe(
			(res) => {
				this.loader.hide();
				this.regularNotes = res || [];
				this.notes = res || [];
				this.checkAndGetNotes();
			},
			(error) => {
				this.loader.hide();
				this.alert.error('Failed to get note. Please contact system administrator', error);
			}
		);
		this.loader.show();
		this.caseDetailService.getADRNotes(this.systemicCaseId).subscribe(
			(res) => {
				this.loader.hide();
				this.adrNotes = res || [];
				this.checkAndGetNotes();
			},
			(error) => {
				this.loader.hide();
				this.alert.error('Failed to get ADR notes. Please contact system administrator', error);
			}
		);
	}
	updateNotes(systemicCaseId: number) {
		this.systemicCaseId = systemicCaseId;
		this.getNotes();
	}

	checkAndGetNotes() {
		if (this.isAdrRoleHolder && this.selectedIndexName === 'ADR') this.notes = [...(this.adrNotes || [])];
		else this.notes = [...(this.regularNotes || [])];
	}

	getSystemicCases() {
		this.loader.show();
		this.selection.clear();
		this.dashboardServ.getSystemicCaseInformation(this.systemicStatus != 'CLOSED').subscribe(
			(res) => {
				this.loader.hide();
				this.systemicCaseArray = res?.length
					? res.sort((a, b) => (new Date(b.createdOn).getTime() < new Date(a.createdOn).getTime() ? -1 : 1))
					: [];

				if (['WATCH LIST', 'INVESTIGATION'].includes(this.systemicStatus)) {
					this.systemicCaseArray = res?.filter(
						(item) => item.status?.description?.toUpperCase() === this.systemicStatus
					);
				}

				this.dataSource.data = this.systemicCaseArray;
				this.dataSource._updateChangeSubscription();
				if (this.systemicCaseId) {
					this.stepper.next();
					if (this.dataSource.data?.find((item) => item?.systemicCaseId === this.systemicCaseId))
						this.loadCase(this.dataSource.data?.find((item) => item?.systemicCaseId === this.systemicCaseId));
				}
			},
			(err) => {
				this.loader.hide();
				this.alert.error('Error happend while getting systemic cases. Please contact help desk.', err);
			}
		);
	}

	getUserSubscribedSystemicCaseIdList() {
		this.cmnServ
			.getUserDetails()
			.pipe(takeWhile(() => this.observer$.value))
			.subscribe((res) => {
				if (Utils.notNullCondition(res)) {
					this.dashboardServ
						.getSubscribedSystemicCases(res?.userId)
						.subscribe((res) => (this.userSubscribedCaseIdList = [...res]));
				}
			});
	}

	public isUserSubscribed(systemicCaseId: number) {
		return this.userSubscribedCaseIdList?.includes(systemicCaseId);
	}

	getSharedCodes() {
		this.sharedCodeServ.getAllegationSBI().subscribe(
			(res) => this.getAllegationLookup(res),
			(error) => this.alert.error('An error occurred while getting allegation SBI.', error)
		);
	}

	private getAllegationLookup(allegationsComb: StatuteVO[]) {
		this.statuteLookup = allegationsComb;
		this.statuteLookup.forEach((item) => (this.basisLookup = this.basisLookup.concat(item.basis)));
		this.basisLookup = _.uniqBy(this.basisLookup, 'code');
		this.basisLookup.forEach((item) => (this.issueLookup = this.issueLookup.concat(item.issue)));
		this.issueLookup = _.uniqBy(this.issueLookup, 'code');
	}
	getSystemicActivity(systemicCaseId) {
		this.logs = [];
		this.sharedPartiesServ.getSystemicEventLogs(systemicCaseId).subscribe((res) => {
			this.logs = res || [];
		});
	}

	public fetchSystemicCaseDetails(detail: SystemicCaseDetailResponse): Observable<any[]> {
		const ids = detail.chargesRelated.map((i) => i.caseId);
		if (ids.length > 0) {
			const requests = [];
			let t: WsCasesResponseInterface;
			this.cmnServ.sliceIntoChunks(ids, 500).forEach((element) => {
				requests.push(this.prepaSearchServ.searchCaseDetailByList(element.join('~')));
			});
			return forkJoin(requests);
		}
		return of([]);
	}

	public loadCase(row: any) {
		this.selectedCase = row;
		this.systemicCaseId = this.currentSystemicCaseId = row.systemicCaseId || row;
		this.getNotes();
		this.loader.show();
		let res;
		this.getSystemicActivity(this.systemicCaseId);
		this.hasEditRight =
			(row && row.ownerId == this.userDetailId) ||
			(row.coOwnerIds || []).some((x) => x == this.userDetailId) ||
			this.cmnServ.getOfficeBasedRoles('ALL').includes(SystemicAdminRoleCode);
		this.dashboardServ
			.getSystemicCaseDetails(this.systemicCaseId, this.systemicStatus === 'CLOSED' ? false : true)
			.pipe(
				mergeMap((detail) => {
					res = detail;
					this.systemicDetail = detail;
					this.isSubscribed = this.isUserSubscribed(this.systemicDetail?.systemicCase?.systemicCaseId);
					this.buttonText = this.isSubscribed ? 'Subscribed' : 'Unsubscribed';
					return this.fetchSystemicCaseDetails(detail);
				}),
				catchError((_) => throwError(null))
			)
			.subscribe(
				(totalResponse: any[]) => {
					let totalRelatedSystemicCharges = [];
					totalResponse?.forEach((element) => {
						element.forEach((item) => (item['systemicCase'] = this.systemicDetail?.systemicCase));
						totalRelatedSystemicCharges = [...totalRelatedSystemicCharges, ...element];
					});

					this.loader.hide();
					res.chargesRelated = res.chargesRelated || [];
					res.chargesRelated.forEach((item) => {
						item.caseDetail = totalRelatedSystemicCharges.find((i) => i.ciChargeInquiryId === item.caseId);
						item.coordinationStatusCode = item.coordinationStatus ? item.coordinationStatus.code : null;
					});
					this.systemicCaseCharges = res.chargesRelated;
					this.relatedSystemicCaseCharges = [
						...res.chargesRelated.filter((x) => x.coordinationStatusCode != 'CRDN_STS2'),
					];
					this.notRelatedSystemicCaseCharges = [
						...res.chargesRelated.filter((x) => x.coordinationStatusCode == 'CRDN_STS2'),
					];
				},
				(err) => {
					this.loader.hide();
					this.alert.error('Error happened while getting systemic case detail. Please contact help desk.', err);
				}
			);
	}

	public modifyCase(systemicCaseId: number, row?: any) {
		this.loader.show();
		this.dashboardServ.getSystemicCaseDetails(systemicCaseId).subscribe(
			(res: any) => {
				if (!row) {
					row = res.systemicCase;
				}
				let hasEditRight =
					(row && row.ownerId == this.userDetailId) ||
					(row.coOwnerIds || []).some((x) => x == this.userDetailId) ||
					this.cmnServ.getOfficeBasedRoles('ALL').includes(SystemicAdminRoleCode);
				this.loader.hide();
				const dialogRef = this.dialog.open(ModifySystemicDialogComponent, {
					width: '1400px',
					data: { systemicDetail: res, isCreateSystemic: row.status.code == 'IN', statutesComb: this.statuteLookup },
					disableClose: false,
					panelClass: 'app-dialog-container-full-height',
					scrollStrategy: ScrollStrategy,
					id: 'modify-systemic-case-dialog',
				});
				dialogRef.componentInstance.hasOGC = this.isOGCAdmin;
				dialogRef.componentInstance.hasEditRight = hasEditRight;
				dialogRef.componentInstance.enableSystemicInvestigation = 'WL';
			},
			(error) => {
				this.loader.hide();
				if (error.status === 422) {
					this.alert.error(error?.error , error);
				} else {
					this.alert.error('Error happened while getting systemic case detail. Please contact help desk.', error);
				}
			}
		);
	}

	/**
	 * @description filter content on one column
	 * @param filterValue filter query
	 * @param column column to filter on
	 * @todo put this function in a reusable location
	 */
	applyColumnFilter(filterValue: string, column: string) {
		this.filters[column] = filterValue;
		this.dataSource.filter = this.filters;
		if (this.dataSource.paginator) {
			this.dataSource.paginator.firstPage();
		}

		// For aria alert when user uses filter
		this.ariaResultAlert = this.dataSource.filteredData.length;
	}

	public convertAllegationsToDescription(codeArray: string[], lookup: any[]): string {
		if (Utils.isEmptyCondition(codeArray)) {
			return '';
		}
		return codeArray.map((i) => this.getAllegationDescriptionByCode(i, lookup)).join(',\n');
	}

	/**
	 * @description get allegation description by code. note that costom issues cannot find any matches,
	 * just return code in that case.
	 * @param code
	 * @param lookup
	 */
	private getAllegationDescriptionByCode(code: string, lookup: any[]): string {
		const item = lookup.find((i) => i.code === code);
		return item ? item.shortName : code;
	}

	public isEnableDelete(rows) {
		return (
			rows.length > 0 &&
			rows.every(
				(row) =>
					this.isSystemicRoleHolder ||
					row?.ownerId == this.userDetailId ||
					(row?.coOwnerIds || []).some((x) => x === this.userDetailId)
			)
		);
	}

	public confirmRemoveSystemicCases(rows, type = 'remove') {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: type == 'remove' ? CONFIRM_REMOVE_SYSTEMIC_CASE : CONFIRM_DELETE_SYSTEMIC_CASE,
			disableClose: true,
			scrollStrategy: ScrollStrategy,
			id: 'confirm-remove-systemic-case-dialog',
		});
		dialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((res) => {
				if (res) {
					this.removeSystemicCases(rows, type);
				}
			});
	}

	private removeSystemicCases(rows, type) {
		const requests = rows.map((item) => this.dashboardServ.deleteOrCloseSystemicCase(item.systemicCaseId, type));
		this.loader.show();
		forkJoin(requests).subscribe(
			(resArray) => {
				this.loader.hide();
				this.alert.success(`Systemic case(s) ${type == 'remove' ? 'removed' : 'deleted'} successfully.`);
				this.systemicCaseId = undefined;
				this.getSystemicCases();
			},
			(error) => {
				this.loader.hide();
				if (error.status === 422) {
					this.alert.error(error?.error , error);
				} else {
					this.alert.error('Error happened while removing systemic case(s). Please contact help desk.', error);
				}
			}
		);
	}

	public toggleSubscription(systemicCaseId: number) {
		const systemicCase = this.systemicCaseArray?.find((item) => item?.systemicCaseId === systemicCaseId);
		if (!this.isUserSubscribed(systemicCaseId)) this.confirmSubscribe(systemicCase);
		else this.confirmUnsubscribe(systemicCase);
	}

	public confirmSubscribe(row = null) {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: CONFIRM_SUBSCRIBE_SYSTEMIC_CASE,
			disableClose: true,
			scrollStrategy: ScrollStrategy,
			id: 'confirm-subscribe-systemic-case-dialog',
		});
		dialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((res) => {
				if (res) {
					if (row) {
						this.subscribeToSystemicCases([row]);
					} else {
						this.subscribeToSystemicCases(this.selection.selected);
					}
				}
			});
	}

	private subscribeToSystemicCases(systemicCases: SystemicCaseResponse[]) {
		this.loader.show();
		const requests = systemicCases.map((systemicCase) => {
			const systemicCaseId = systemicCase.systemicCaseId;
			return this.dashboardServ.subscribeSystemicCase(systemicCaseId);
		});
		forkJoin(requests).subscribe(
			(_) => {
				this.loader.hide();
				this.alert.success('Successfully subscribed to selected case(s).');
				this.getUserSubscribedSystemicCaseIdList();
				this.isSubscribed = true;
				this.buttonText = this.isSubscribed ? 'Subscribed' : 'Unsubscribed';
			},
			(error) => {
				this.loader.hide();
				if (error.status === 422) {
					this.alert.error(error?.error , error);
				} else {
					this.alert.error('Error happed while subscribing. Please contact help desk.', error);
				}
			}
		);
	}

	public confirmUnsubscribe(row = null) {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: CONFIRM_UNSUBSCRIBE_SYSTEMIC_CASE,
			disableClose: true,
			scrollStrategy: ScrollStrategy,
			id: 'confirm-unsubscribe-systemic-case-dialog',
		});
		dialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((res) => {
				if (res) {
					if (row) {
						this.unsubscribeToSystemicCases([row]);
					} else {
						this.unsubscribeToSystemicCases(this.selection.selected);
					}
				}
			});
	}

	private unsubscribeToSystemicCases(systemicCases: SystemicCaseResponse[]) {
		this.loader.show();
		const requests = systemicCases.map((systemicCase) => {
			const systemicCaseId = systemicCase.systemicCaseId;
			return this.dashboardServ.unSubscribeSystemicCase(systemicCaseId);
		});
		forkJoin(requests).subscribe(
			(_) => {
				this.loader.hide();
				this.alert.success('Successfully unsubscribed to selected case(s).');
				this.getUserSubscribedSystemicCaseIdList();
				this.isSubscribed = false;
				this.buttonText = this.isSubscribed ? 'Subscribed' : 'Unsubscribed';
			},
			(error) => {
				this.loader.hide();
				if (error.status === 422) {
					this.alert.error(error?.error , error);
				} else {
					this.alert.error('Error happed while unsubscribing. Please contact help desk.', error);
				}
			}
		);
	}

	public confirmRemoveFromSystemic(payload: number[]) {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: CONFIRM_REMOVE_CASES_FROM_SYSTEMIC,
			disableClose: true,
			scrollStrategy: ScrollStrategy,
			id: 'confirm-remove-from-systemic-dialog',
		});
		dialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((res) => {
				if (res) {
					this.removeFromSystemic(payload);
				}
			});
	}

	private removeFromSystemic(payload: number[]) {
		this.loader.show();
		this.dashboardServ.deleteSystemicCaseCharges(this.systemicDetail.systemicCase.systemicCaseId, payload).subscribe(
			(res) => {
				this.loader.hide();
				this.alert.success('Case(s) removed from systemic case successfully.');
				this.loadCase(this.systemicDetail.systemicCase);
				this.getUserSubscribedSystemicCaseIdList();
			},
			(error) => {
				this.loader.hide();
				if (error.status === 422) {
					this.alert.error(error?.error , error);
				} else {
					this.alert.error('Error happened while removing case(s). Please contact help desk.', error);
				}
			}
		);
	}

	/**
	 * @description controls the master toggle.
	 * On select: select every row.
	 * On unselect: clear selection.
	 * @param event
	 */
	public masterToggle(event) {
		if (event.checked) {
			this.dataSource.filteredData.forEach((a) => this.selection.select(a));
		} else {
			this.selection.clear();
		}
	}

	// private generateSystemicCasePayLoad(res: SystemicCaseDetailResponse): SystemicCaseVO {
	// 	const payload: SystemicCaseVO = {
	// 		caseName: res.systemicCase.caseName,
	// 		description: res.systemicCase.description,
	// 		caseCriteria: { ...res.systemicCase.caseCriteria },
	// 		//type: { ...res.systemicCase.type },
	// 		office: { ...res.systemicCase.office },
	// 		status: { ...res.systemicCase.status },
	// 		ownerId: res.systemicCase.ownerId,
	// 		additionalIssues: res.systemicCase.additionalIssues,
	// 		notificationRecipientsVOS: res.notificationRecipients.map((item) => {
	// 			return {
	// 				recipientId: item.recipientId,
	// 				isCoOwner: item.isCoOwner,
	// 			};
	// 		}),
	// 		chargesToRelate: res.chargesRelated.map((item) => {
	// 			return {
	// 				chargeId: item.caseId,
	// 				coordinationStatus: item.coordinationStatus,
	// 			};
	// 		}),
	// 	};
	// 	return payload;
	// }

	public clearDetailTable() {
		this.systemicCaseCharges = [];
		this.systemicDetail = null;
	}

	public navigateToSystemicModule(systemicCaseId: number) {
		this.systemicCaseId = systemicCaseId;
		this.router.navigateByUrl('/systemic-investigation', { state: { systemicCaseId: systemicCaseId } });
	}

	hasOGC(officeRole: OfficeRole): boolean {
		const roleCode = officeRole?.role?.roleCode;
		return (
			roleCode?.includes('PRIVATE_ATTORNEY') || this.cmnServ.getOfficeBasedRoles('ALL')?.includes(OGCAdminRoleCode)
		);
	}

	getDocumentTypes() {
		this.docServ.getDocumentAllTypes().subscribe(
			(res) => {
				this.documentTypes = res.filter((x) => !x.isObsolete);
			},
			(error) => {
				this.alert.error('Error happened while getting documents. Please contact help desk.', error);
			}
		);
	}

	public isDocumentPublished(document): boolean {
		return document?.isPublished;
	}

	fileNotUpdatable(file): boolean {
		const docType = this.documentTypes.find((item) => item.documentCode === file.documentType);
		return !(
			docType &&
			docType.isUpdateable &&
			!file.isPublished &&
			(!['POSSTREDAC', 'PRVPOS', 'STMTPSANC'].includes(file.documentType) || !this.checkIsReleased())
		);
	}

	checkIsReleased() {
		return this.documents.some((x) => ['POSSTREDAC', 'PRVPOS'].includes(x.documentType) && x.isPublished);
	}
	onDocumentsInit(docs) {
		this.documents = docs || [];
	}

	public hasRecall(document): boolean {
		return (
			document.isPublished && document.createdByFullName.toLowerCase() !== 'publicportal'
			// !['publicportal', 'respondent'].some((x) => document.createdByFullName.toLowerCase().includes(x))
		);
	}

	/**
	 * showing the edit dialog
	 * @param: doc
	 */
	showRowEditDialog(doc: any, docList: any) {
		const isCodExist = this.documents.some((x) => x.documentType == DocTypes.COD || x.documentType == DocTypes.PCOD);
		const isCodDraftExixt = this.documents.some((x) => x.documentType == DocTypes.COD_DRAFT);

		this.documentBeforeEdit = doc;
		this.documentAfterEdit = _.cloneDeep(doc);
		const data = {
			from: 'edit',
			categoryTypes: [],
			data: doc,
			documentTypes: this.documentTypes,
		};
		this.documentDialogRef = this.dialog.open(DocumentDialogComponent, {
			data,
			disableClose: true,
			scrollStrategy: ScrollStrategy,
			id: 'edit-document-dialog',
		});
		this.documentDialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((res: any) => {
				if (res) {
					if (DocTypes.COD == res.documentType) {
						let msg = '';
						if (isCodExist) {
							msg = 'COD Already Exist';
						} else if (!isCodDraftExixt) {
							msg = 'Draft not exist';
						}
						if (msg) {
							this.alert.warn(msg);
							return;
						}
					}
					this.documentAfterEdit.title = res.title;
					this.documentAfterEdit.fileName = StringUtils.renamefile(this.documentAfterEdit.fileName, res.title);
					this.documentAfterEdit.documentType = res.documentType;
					this.documentAfterEdit.tabType = res.tabType === 'null' ? null : res.tabType;
					this.documentAfterEdit.relatedDate = res.relatedDate
						? moment(new Date(res.relatedDate)).format('MM-DD-YYYY')
						: undefined;
					this.documentAfterEdit.responseDueDate = res.responseDueDate
						? moment(new Date(res.responseDueDate)).format('MM-DD-YYYY')
						: undefined;
					this.relatedDateToBeEdited = res.relatedDate;
					this.saveEditedDocument(docList);
				}
			});
		this.documentDialogRef.componentInstance.isSystemic = true;
	}

	/**
	 * saving the edited document if dialog returns yes
	 */
	saveEditedDocument(docList: any) {
		if (DocumentsUtil.validateEdit(this.documentAfterEdit, this.documents, UserType.Private, this.alert)) {
			// change the isPublished to false if the document type is either POS or POS redacted
			if (
				this.documentAfterEdit.documentType === DocTypes.POS ||
				this.documentAfterEdit.documentType === DocTypes.POS_REDACT ||
				this.documentAfterEdit.documentDescription === DocTypes.RFI ||
				this.documentAfterEdit.documentDescription === DocTypes.POS_ATTMNT_NON_CONF ||
				this.documentAfterEdit.documentType === DocTypes.POS_ATTMNT_NON_CONF_REDACT
			) {
				this.documentAfterEdit.isPublished = false;
			}
			// flag to send to ecm to add entry in activity log
			this.loader.show();
			this.docServ
				.editDocument(
					this.documentAfterEdit,
					'SYSTEMIC',
					this.cmnServ.userToken,
					this.userSelectedOfficeCode,
					this.systemicCaseId?.toString()
				)
				.subscribe(
					(res) => {
						if (!_.isEmpty(res)) {
							// using lodash _.isEmpty method to check if the object is empty
							this.alert.success('Document has been edited.');
							docList?.getSystemicDocuments();
							if (res.documentDescription === DocTypes.RFI) {
								// this.updateRfiResponseDueDate(res);
							}
						}
						this.loader.hide();
					},
					(error) => {
						this.loader.hide();
						if (error.status === 422) this.alert.error(error?.error , error);
						else
							this.alert.error(
								'Encountered an error updating the document properties. Please check with system administrator.', error
							);
					}
				);
		}
	}

	toggleDocumentDisclosable(doc: any, docList) {
		const actionType = doc.isDisclosable ? 'Non-disclosable' : 'Disclosable';
		const ToggleDisclosableConfirmation = {
			header: `Make ${actionType}`,
			question: `Are you sure you would like to make this document <b> ${actionType} </b> ?`,
			actionType: actionType,
			information: actionType === 'Non-disclosable' ? NonDisclosableMessage : DisclosableMessage,
			button: `Make ${actionType}`,
			textarea: false,
		};
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			data: ToggleDisclosableConfirmation,
			width: '40%',
			disableClose: true,
			scrollStrategy: ScrollStrategy,
			id: 'toggle-disclosable-confirmation-dialog',
		});
		dialogRef
			.afterClosed()
			.pipe(take(1))
			.subscribe((result) => {
				if (result) {
					this.loader.show();
					this.docServ
						.updateDocumentParams(
							doc,
							'SYSTEMIC',
							this.cmnServ.userToken,
							this.userSelectedOfficeCode,
							undefined,
							undefined,
							!doc.isDisclosable,
							this.systemicCaseId?.toString()
						)
						.subscribe(
							(res) => {
								this.loader.hide();
								if (!_.isEmpty(document)) {
									this.alert.success(`${doc.fileName} has been made ${actionType}`);
								}
								docList?.getSystemicDocuments();
							},
							(error) => {
								this.loader.hide();
								if (error.status === 422) this.alert.error(error?.error?.message);
								else {
									this.alert.error(
										'Encountered an error publishing the document. Please check with system administrator', error
									);
									docList?.getSystemicDocuments();
								}
							}
						);
				}
			});
	}

	ngOnDestroy(): void {
		this.observer$.next(false);
	}
}
